import billingApiModule from '../billingApi.module';

class BillingInvoicesApiService {
    constructor(__env, apiUtil, authenticationConstants) {
        this.__env = __env;
        this.apiUtil = apiUtil;
        this.authenticationConstants = authenticationConstants;
    }

    getInvoices(params) {
        return this.apiUtil.getWithBearerAuth(
            this.authenticationConstants.billing.name,
            `${this.__env.billingApiUrl}/api/v1/invoices`,
            { params }
        );
    }
}

export default billingApiModule.service(
    'billingInvoicesApiService',
    BillingInvoicesApiService
);



// WEBPACK FOOTER //
// ./modules/billingApi/invoices/billingInvoicesApi.service.js